import { Contact } from './contact'
import { User } from './user'
import { Address } from './address'
import { Currency, IPagination, IQueryParams } from './common'
import { IBaseInfoColumn } from './baseInfo'
import { EPaymentBrand } from './enum'

export enum EAuditConfigType {
  ExchangeRate = 'exchangeRate',
  RiskControl = 'riskControl',
  Store = 'store',
  TransRefund = 'transRefund',
  Operation = 'operation',
}

export interface IAcquirerQueryParams extends IQueryParams {
  startTime?: string
  endTime?: string
  insCode?: string
  insName?: string
  // more
}

export class Acquirer {
  institution: Institution
  qrChannels: QrChannel[] = []
  cardChannels: ICardChannel[] = []
  users: User[] = []

  constructor() {
    this.institution = new Institution()
  }
}

export class Institution {
  common: Common
  qr: AcquirerQr
  card: AcquirerCard
  version: number
  createdAt: string
  updatedAt: string

  constructor() {
    this.common = new Common()
    this.qr = new AcquirerQr()
    this.card = new AcquirerCard()
  }
}
// æ¸ éä¿¡æ¯
export class QrChannel {
  id: string
  chanCode: EPaymentBrand // æ¸ éä»£ç 
  paymentBrand: EPaymentBrand // æ¯ä»åç
  chanMerID?: string // æ¸ éåæ·å·ï¼æ¯ä»å®ï¼PIDï¼
  chanMerName?: string // æ¸ éåæ·åç§°
  // key: string // å¯é¥
  currencies?: Currency[] // å¸ç§
  fee?: number // äº¤æè´¹ç
  version?: number
  dynamicQrPrefix?: string
  staticQrPrefix?: string
  isSupportSettleCrr?: boolean
  publicKey?: string
  privateKey?: string
  isLoaded?: boolean // æ¯å¦æ¯å è½½å·²æçæ¸ é
}

export interface WXChannel extends QrChannel {
  signKey: string // API secret TODO
  publicKey: string // API Cetificate
  privateKey: string // API Cetificate åå°è¿åçå­æ®µ
  privateKeyArray: string[] // æ°å¢æ¶ä½¿ç¨çå­æ®µ
  appID: string // WeChat APP ID
  isSupportPreAuth?: boolean
}

export interface ALPChannel extends QrChannel {
  signKey: string // MD5 Key
  publicKey: string // Alipay RSA Public Key
  privateKeyArray: string[] // RSA Private Key æ°å¢æ¶ä½¿ç¨çå­æ®µ
  privateKey: string // åå°è¿åçå­æ®µ
  appID: string // alpAppId
  settleCurrency: string // Settlement Currency
  /** settlement 0, transaction 1 */
  settType: number
  sftp: SFTP
  isSupportPreAuth: boolean
}

export interface UPIChannel extends QrChannel {
  chanMerIDSecondary: string
  settleCurrency: string
  chanInsCode: string
  signKey: string
  encryptKey: string
  signKeyID: string
  encryptKeyID: string
}
export class CardChannel extends QrChannel {
  /**
   * æ¥å¥æ¨¡å¼: Offline System
   */
  accessMode: EAccessMode

  /**
   * the Institution Code in the Offline System
   */
  offlineInsCode: string

  /**
   * the Channel Institution Code in the Offline System
   */
  offlineChannelInsCode: string

  /**
   * çº¿è·¯å°åIP
   */
  lineIP: string
  /**
   * çº¿è·¯ç«¯å£port
   */
  port: number
}

export interface ICardChannel extends QrChannel {
  /**
   * æ¥å¥æ¨¡å¼: Offline System
   */
  accessMode?: EAccessMode

  /**
   * the Institution Code in the Offline System
   */
  offlineInsCode?: string

  /**
   * the Channel Institution Code in the Offline System
   */
  offlineChannelInsCode?: string

  /**
   * çº¿è·¯å°åIP
   */
  lineIP?: string
  /**
   * çº¿è·¯ç«¯å£port
   */
  port?: number
}

export interface ICardChannelVisa extends ICardChannel {
  bin: string
}

export interface ICardChannelMasterCard extends ICardChannel {
  bin: string
  ica: string
}

export interface ICardChannelAmex extends ICardChannel {
  mcc?: string
  chanAddrEn?: string
  chanNameEN?: string
  first3DigitsOfSENumber?: string
  ain?: string,
}
export interface ICardChannelAmericanExpress extends ICardChannel {
  /**
   * ACquirer Identifier Number, assigned by AME
   */
  ain: number

  /**
   * First 3 digits of S/E Number
   */
  first3DigitsOfSENumber: number
}

export class AcquirerQr {
  isRefundAsync = false
  isSupportTips = false
  isCollectQRCodeAmountFixed = false
  tradeTypes: string[] = []
  autoAlpApply = false
  autoWxpApply = false

  constructor() {}
}

export class AcquirerCard {
  isRefundAsync = false
  tradeTypes: string[] = []
}

export class Common {
  /* æ°æ¥å£ */
  public insCode: string // æºæç¼å·
  public insNameEN: string // æºæåç§°(è±æ)

  public insName: string // æºæåç§°ï¼æ¬å°ï¼
  public contact: Contact // èç³»äººä¿¡æ¯
  public address: Address // æºæå°å
  public businessArea: string // ä¸»è¦ä¸å¡åºå
  public currencies: Currency[] = [] // äº¤æå¸ç§
  public settleInfo: Settle
  public auditConfigs: AuditConfig[] = []
  public feature: MerchantFeature
  public tradeInfo: TradeInfo
  public status: string

  // TODO: æ¸ç®ä¿¡æ¯è¿æªå¤ç
  constructor() {
    this.contact = new Contact()
    this.address = new Address()
    this.settleInfo = new Settle()
    this.tradeInfo = new TradeInfo()
    this.feature = new MerchantFeature()
  }
}

export class Settle {
  reportList: string[] = []
}

export class Step {
  stepID: number
  stepName: string
}

export class AuditConfig {
  type: EAuditConfigType
  stepNumber: number
  steps?: Step[] = []
}

export class MerchantFeature {
  multiTransCurrConfig: boolean
  isSupportRisk: boolean
  isSupportPostRisk: boolean
  isSupportDualMessage = false
}

export class TradeInfo {
  exchangeRates: ExchangeRate[] = []
  access: Access[] = []

  constructor() {}
}

export enum AccessMode {
  Merchant = 'merchant',
  Acquirer = 'acquirer',
  Node = 'node',
}

export class Access {
  mode: AccessMode
  key?: string
}

// å¸ç§è½¬æ¢ä¿¡æ¯
export class ExchangeRate {
  // id: string
  srcCurrency: string
  dstCurrency: string
  buyRate: number
  selRate?: number
  markup: number
  rateSponsor: string // è½¬æ¢æ±çåç§°
  isFixed?: boolean // åºå®å¼
  isBest?: boolean // æä¼å¼

  createdAt?: string
  updatedAt?: string
  effectedAt?: string
}

export interface IExchangeRateInput {
  rateSponsor?: string
  selRate: number | string
  isFixed?: boolean
  isBest?: boolean
}

export interface SFTP {
  username: string
  password: string
  filePath: string
}

// æ«ç éç½®
export class QRConfig {
  autoAlpApply: boolean
  autoWxpApply: boolean
  isCollectQRCodeAmountFixed: boolean
  isRefundAsync: boolean
  isSupportTips: boolean
  tradeTypes: string[] = []
}

// å¡éç½®
export class CardConfig {
  isRefundAsync: boolean
  tradeTypes: string[] = []
}

export interface IAcquirerPagination extends IPagination {
  data: Acquirer[]
}

export interface IInstitutionPagination extends IPagination {
  data: Institution[]
}

export interface ICommonPagination extends IPagination {
  data: Common[]
}

// æ´æ°åºç¡ä¿¡æ¯è¯·æ±ä½
export interface IUpdateAcquirerBaseInfo {
  version: number
  common: {
    insName?: string;
    insNameEN?: string;
    contact?: Contact;
    address?: Address;
    businessArea?: string;
    currencies?: Currency[];
  }
}

// æ´æ°äº¤æä¿¡æ¯è¯·æ±ä½
export interface IUpdateAcquirerTradeInfo {
  version: number
  trade: TradeInfo
}

// æ´æ°åæ·åè½éç½®è¯·æ±ä½
export interface IUpdateAcquirerFeature {
  version: number
  feature: MerchantFeature
}

// æ´æ° QR åè½ä¿¡æ¯è¯·æ±ä½
export interface IUpdateAcquirerQRFeature {
  version: number
  feature: AcquirerQr
}

// æ´æ° å¡åè½ä¿¡æ¯è¯·æ±ä½
export interface IUpdateAcquirerCardFeature {
  version: number
  feature: AcquirerCard
}

// æ´æ°å®¡æ ¸è¯·æ±ä½
export interface IUpdateAcquirerAudit {
  version: number
  auditConfigs: AuditConfig[]
}

// æ´æ° æ¸ç®ä¿¡æ¯è¯·æ±ä½
export interface IUpdateAcquirerSettlement {
  version: number
  settlement: Settle
}

// è¯¦ææ¸ éä¿¡æ¯
export interface IChannelInfo {
  imgUrl: string
  channelName?: string /** æ¸ éåç§° */
  channelColumns: Array<IBaseInfoColumn[]>
}

export enum EAccessMode {
  CIL = 'OFI', // è®¯èçº¿ä¸
  AME = 'AME', // ç¾è¿
  HKG = 'HKG', // é¦æ¸¯èç¹
}

export const AccessModeMap = {
  OFI: 'Offline System',
  AME: 'American Express Network Service',
  HKG: 'Hong Kong Gateway',
}
